import React, { useContext, useEffect, useState } from 'react';

import ReactTooltip from 'react-tooltip';

// Helpers.
import Helper from '../../helpers/Helper';

// Types.
import { ActivityBatchGroup } from '../../types/instance/Activity';
import Wait from '../../types/instance/Wait';
import { TimeRangeContext } from "../../context/TimeRangeContext";
import api from "../../api/Base";

function GroupedBatchBreakdown(props: { batch: ActivityBatchGroup, waits: Wait[], instanceId: number, instanceTime?: number, maxWaitTime?: number, filterParameters: string }) {
    const [waits, setWaits] = useState<Wait[]>([]);
    const timeRangeContext = useContext(TimeRangeContext)

    // Calculate batchWeight for rendering
    let batchWeight: number = 0;

    if (props.maxWaitTime) {
        batchWeight = Math.floor((100 / props.maxWaitTime) * props.batch.waittime);
    } else if (props.instanceTime) {
        // Fallback to instanceTime if maxWaitTime is not provided
        batchWeight = Math.floor((100 / props.instanceTime) * props.batch.waittime);
    }

    useEffect(() => {

        const getBatchWaits = async () => {

            // Get the batch waits.
            api.get(`activity/waitevent?${timeRangeContext.getTimeRangeQueryString()}&sort=waittime+desc&id=${props.instanceId}&batchgrouphash=${props.batch.batchgrouphash}${props.filterParameters}`)
                .then(async (response: { data: Wait[]; }) => {

                    let batchWaits: Wait[] = response.data;

                    // Build top waits pie chart.
                    for (let index = 0; index < batchWaits.length; index++) {

                        // Look for a matching passed wait state.
                        let matchedWaits: Wait[] = props.waits.filter(wait => wait.waitevent === batchWaits[index].waitevent);

                        if (matchedWaits.length > 0) {

                            // Use the matched wait colour.
                            batchWaits[index].color = matchedWaits[0].color;
                        } else {

                            // Unmatched wait, so use the generic colour.
                            batchWaits[index].color = '#999';
                        }

                        // Work out the wait percentage.
                        const weight = Math.floor((100 / props.batch.waittime) * batchWaits[index].waittime);

                        // Set the batch weight and build the tooltip.
                        batchWaits[index].weight = weight;

                    }

                    setWaits(batchWaits);
                })
                .catch((error: any) => {
                    console.error('Failed to retrieve wait event for batch.', error);
                });
        }

        if (props.instanceTime) {
            getBatchWaits();
        }

    }, [props.batch.batchgrouphash, props.waits, props.instanceTime, props.filterParameters, props.instanceId, timeRangeContext]);

    if (batchWeight < 5) {
        return (
            <React.Fragment>-</React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div style={{ width: `${batchWeight}%` }} data-tip={`<p class="mb-2">This batch has the following top waits:</p><ol class="list-unstyled mb-0">${waits.filter(wait => wait.weight && wait.weight > 0).map(wait =>
                `<li class="d-flex justify-content-between align-items-center"><span>${wait.waitevent}:</span> <span class="ms-3 text-end">${Helper.getTimeInEnglish(wait.waittime)} (${wait.weight}%)</span></li>`
            ).join('')}</ol>`} data-html={true}>
                {waits.filter(wait => wait.weight && wait.weight > 0).map((wait: Wait, index) => (
                    <div key={index} style={{ width: `${wait.weight}%`, backgroundColor: wait.color }}>&nbsp;</div>
                ))}
            </div>
            <ReactTooltip className="tooltip" effect="solid" html={true} />
        </React.Fragment>
    );
}

export default GroupedBatchBreakdown;
